export function padGrid(grid: boolean[][]): boolean[][] {
  const blankColumn = new Array(12).fill(false);
  return [
    blankColumn,
    ...grid.map((row) => [false, ...row, false]),
    blankColumn,
  ];
}
